import React, { memo, useCallback, useEffect, useState } from "react"
import {
    CardContent,
    Collapse,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core"
import Card from "shared/Components/Card/Card"
import { Localized } from "@fluent/react"
import {
    IBasketMeetingPlanningFormField,
    IDeliveryFormExtraServiceItem, IEditMeetingOrderData
} from "shared/Types/MeetingPlanning/deliveryForm"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown"
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp"
import { useFormikContext } from "formik"
import { FormInputField, InputType } from "shared/Modules/Forms/formTypes"
import ExtraServicesControl from "shared/Components/Form/ExtraServicesControl"

const useDeliveryFormStyles = makeStyles((theme) => ({
    mr_2: {
        marginRight: theme.spacing(2),
    },
    mb_2: {
        marginBottom: theme.spacing(2),
    },
    mb_3: {
        marginBottom: theme.spacing(3),
    },
    card: {
        marginTop: '16px !important',
        marginBottom: '16px !important'
    },
    cardContent: {
        padding: '16px !important'
    },
    collapse: {
        width: '100%',
        minHeight: '30px !important',
        visibility: 'visible',
    },
    title: {
        cursor: 'pointer',
        marginBottom: theme.spacing(4),

        '& *': {
            cursor: 'pointer',
        }
    }
}))

export function useExtraServicesFormFields(initialMeetingPlanningData: IEditMeetingOrderData | null): FormInputField[] {
    return [
        {
            name: "extraServices",
            type: InputType.EXTRA_SERVICES,
            valueType: "array",
            initialValue: [],
            validations: [],
        },
    ]
}

const MeetingPlanningExtraServicesForm = ({ initialMeetingPlanningData }: { initialMeetingPlanningData: IEditMeetingOrderData | null }) => {
    const classes = useDeliveryFormStyles()
    const { values, setFieldValue } = useFormikContext<IBasketMeetingPlanningFormField>()

    const [isCollapsed, setIsCollapsed] = useState(true)

    const toggleCollapse = useCallback(() => {
        setIsCollapsed(prev => !prev)
    }, [setIsCollapsed])

    useEffect(() => {
        setFieldValue("extraServices", values.extraServices.map((service) => {
            // @ts-ignore
            const seatPrice = service.basePrice * values.NUMBER_OF_SEATS
            const min = service.mininumPrice?.amount ?? 0
            const max = service.maximumPrice?.amount ?? Number.MAX_SAFE_INTEGER

            const clampedPrice = Math.min(Math.max(seatPrice, min), max)

            return {
                ...service,
                amount: clampedPrice
            }
        }))
        // @ts-ignore
    }, [values.NUMBER_OF_SEATS])

    const handleSelectExtraServices = useCallback((services: IDeliveryFormExtraServiceItem[]) => {
        setFieldValue("extraServices", services)
    }, [setFieldValue])

    return <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
            <Collapse in={isCollapsed} className={classes.collapse}>
                <Grid item container direction="column" wrap="nowrap" justifyContent="flex-start">
                    <Grid item container alignItems="center" justifyContent="space-between" className={classes.title} onClick={toggleCollapse}>
                        <Localized id="delivery-form-delivery-extra-services-title">
                            <Typography variant="h6">
                                Ekstra Services
                            </Typography>
                        </Localized>
                        <FontAwesomeIcon icon={isCollapsed ? faChevronUp : faChevronDown}/>
                    </Grid>
                    <Grid item>
                        <ExtraServicesControl name={"extraServices"} seats={values.seats} selectedServices={values.extraServices} setSelectedServices={handleSelectExtraServices} />
                    </Grid>
                </Grid>
            </Collapse>
        </CardContent>
    </Card>
}

export default memo(MeetingPlanningExtraServicesForm)
